import React, { useState, useEffect, memo } from "react"
import { isSafari } from "react-device-detect"
import { getCartLandingPagePath } from "@/utils/cart"
import useWindowResize from "@/hooks/useWindowResize"
import cartIcon from "@/public/icons/cart-icon.svg"
import cartEmptyIcon from "@/public/icons/cart-icon-empty.svg"
import cartGray from "@/public/icons/cart-gray.svg"
import cartGrayFilledIcon from "@/public/icons/cart-filled.svg"
import { initPrerender } from '@/utils/prerender'

const MiniCart = ({
  eventHandler: {
    store: { cartCount, ariaLabel },
    callbacks: { onClick },
  },
  checkoutPage,
}) => {
  const [width] = useWindowResize()
  const getWidth =
    window.outerWidth === 0
      ? window.innerWidth
      : isSafari
      ? window.innerWidth
      : window.outerWidth
  const [isMobile, setIsMobile] = useState((getWidth || width) <= 1200)
  const [cartUrl, setCartUrl] = useState("")
  useEffect(() => {
    !checkoutPage
      ? setIsMobile((getWidth && width) <= 1200)
      : setIsMobile(false)
  }, [getWidth, width, checkoutPage])
  useEffect(() => {
    getCartLandingPagePath().then(res => {
      setCartUrl(res)
    })
    const regex = /^\/p\/[a-zA-Z0-9-]+\/[a-zA-Z0-9-]*$/
    const isPLPOrPDP = regex.test(window.location.pathname)
    if(!isPLPOrPDP){
      initPrerender()
    }
  }, [])
  return (
    <div
      className={`cart-indicator ${
        cartCount > 0 && "cart-indicator__with-count"
      }`}
    >
      <a
        href={cartUrl}
        aria-label={ariaLabel}
        role="link"
        className="gbh-data-layer"
        data-gbh-data-layer={`{"clickInternalLinks":"true","internalLinkPosition":"global header","internalLinkZoneName":"global header","internalLinkURL":"${cartUrl}","eventMsg":"n/a","eventStatus":"n/a","internalLinkName":"cart icon","eventName":"cart icon","internalLinkType":"global header:navigation","eventType":"global header","eventAction":"cart icon"}`}
      >
        {cartCount ? (
          <div
            className={`cart-indicator__count ${
              cartCount < 100 && "cart-indicator__count--center"
            }`}
          >
            <img
              src={isMobile ? cartGrayFilledIcon?.src : cartIcon?.src}
              alt="Cart"
            />{" "}
            <span>{cartCount}</span>
          </div>
        ) : (
          <img src={isMobile ? cartGray?.src : cartEmptyIcon.src} alt="Cart" />
        )}
      </a>
    </div>
  )
}
const checkForRerender = (prevProps, nextProps) => {
  return (
    nextProps.eventHandler.store.cartCount ===
    prevProps.eventHandler.store.cartCount
  )
}
export default memo(MiniCart, checkForRerender)
